"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.constants = void 0;
exports.constants = {
    MINIBIO_RESUME_OUTDATED_DATE: new Date(2024, 3, 3),
};
//# sourceMappingURL=constants.js.map